import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40e711f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["title"]

import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/store";
import { computed, onMounted, ref } from "vue";
import apis from "@/api";
import type { Website, ToolCatalog } from "@/api/Website";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

expose({ getContentsByCata });

const store = useStore();
const isOwner = computed(() => store.state.common.isOwner);

const currentArticleList = ref<Array<Website>>([]);

function getContentsByCata(id: number) {
  apis.website.getWebsitesByCatalogId2.request<Array<Website>>({ catalogId: id }).then((res) => {
    if (res.data) {
      currentArticleList.value = res.data;
    }
  });
}

function whenSelect(web: Website) {
  window.open(web.url);
}

return (_ctx: any,_cache: any) => {
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createBlock(_component_a_list, {
    "item-layout": "vertical",
    size: "small",
    pagination: false,
    "data-source": currentArticleList.value,
    style: {"background":"#fff"}
  }, {
    renderItem: _withCtx(({ item }) => [
      _createVNode(_component_a_list_item, {
        draggable: "true",
        onClick: ($event: any) => (whenSelect(item))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            title: item.title,
            style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
          }, _toDisplayString(item.title), 9, _hoisted_1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    _: 1
  }, 8, ["data-source"]))
}
}

})